import styled from "styled-components";
import chevronRight0 from "../../../assets/icons/chevron-right1.svg";
import chevronLeft0 from "../../../assets/icons/chevron-left1.svg";
import Archive0 from "../../../assets/icons/archive0.svg";
import LogoutIcon from "../../../assets/icons/log-out-010.svg";
import DotsHorizontal0 from "../../../assets/icons/dots-horizontal0.svg";
import { useContext, useEffect } from "react";
import { StyledChatWindowContent } from "./ChatWindow";
import { Dropdown } from "antd";
import * as Library from "../../../utils/Library";
import AppContext from "../../../contexts/AppContext";

// #region SCOPED CSS
const StyledAllChatsPanel = styled.div`
    &.group-4,
    &.group-4 * {
        box-sizing: border-box;
    }
    &.group-4 {
        flex-shrink: 0;
        position: relative;
    }
    .chat-bot {
        background: var(--backgrounds-and-lines-n-500, #141922);
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-start;
        width: 100%;
        height: auto;
        position: absolute;
        overflow-y: auto;
    }
    .frame-1000011451 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011407 {
        border-radius: 8px;
        padding: 8px 0px 8px 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        transition: background 0.3s ease;
    }
    .hoverable {
        cursor: pointer;
    }
    .frame-1000011407.hoverable:hover {
        background: var(--backgrounds-and-lines-n-200, #262e3e);
        border-radius: 8px;
        cursor: pointer;
    }
    .frame-1000011456 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .chats {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: var(--heading-4-font-size, 18px);
        font-weight: var(--heading-4-font-weight, 400);
        position: relative;
    }
    .chevron-right {
        opacity: 0;
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .chevron-left {
        top: -1px;
        position: relative;
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-1000011452 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .chat-bot2 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011410 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        flex: 1;
        height: 32px;
        position: relative;
        transition: background 0.3s ease;
    }
    .frame-1000011410:hover {
        background: var(--backgrounds-and-lines-n-200, #262e3e);
        border-radius: 8px;
    }
    .frame-100001140722 {
        border-radius: 8px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        background: none;
        border: none;
    }
    .archive {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .archived {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .chevron-right2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-10000114102 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        width: 100%;
    }
    .frame-1000011411 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .today {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        background: none;
    }
    .frame-1000011453 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011412 {
        background: #1e2631;
        border-radius: 8px;
        padding: 16px 8px 16px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        transition: background 0.3s ease;
        cursor: pointer;
    }
    .frame-1000011412:hover {
        background: var(--backgrounds-and-lines-n-200, #262e3e);
    }
    .chat-message-title {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .dots-horizontal {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-1000011413 {
        background: #1e2631;
        border-radius: 8px;
        padding: 16px 8px 16px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .how-to-request-others-to-join-my-company {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    .dots-horizontal2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .yesterday {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011454 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-10000114073 {
        background: #1e2631;
        border-radius: 8px;
        padding: 16px 8px 16px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .how-to-edit-company-info {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        width: 100%;
    }
    .dots-horizontal3 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-10000114074 {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 16px;
        padding: 10px 20px 10px 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-shrink: 0;
        width: 100%;
        position: absolute;

        bottom: 155px;
    }
    .frame-1000011455 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .archive2 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    ._1-chat-archived {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
    }
    .undo {
        color: var(--text-and-icons-blue-500, #00aeef);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
    }
`;
// #endregion

export default function AllChatsPanel({ setShowDeleteDialog }) {
    // #region VARS
    const {
        setAiChatLoading,
        showChatArchived,
        setShowChatArchived,
        aiActiveChats,
        setAiActiveChats,
        aiArchivedChats,
        setAiArchivedChats,
        aiChatWindowOpen,
        aiChatSidePanelOpen,
        showChatAllPanel,
        showChatConversation
    } = useContext(AppContext);

    const currentMessages = showChatArchived ? aiArchivedChats : aiActiveChats;
    // #endregion

    // #region METHODS
    const getUserAIchatsRequest = async (status = "Active") => {
        const formData = {
            status: status
        };

        const res = await Library.makeCommonPostRequest("Global", "getUserAIchats", formData, false, setAiChatLoading);

        if (res?.data?.status !== 200) {
            Library.showToastMessage({
                type: "error",
                message: `Error: ${res?.data?.message || "Failed to fetch AI chats"}`
            });
            return [];
        }

        return res?.data?.data || [];
    };

    const updateAIchatRequest = async (threadID, name, status) => {
        const formData = {
            threadID,
            name,
            status
        };
        const res = await Library.makeCommonPostRequest("Global", "updateAIchat", formData, false, setAiChatLoading);

        if (res?.data?.status !== 200) return;
    };

    const getAIchatMessagesRequest = async threadID => {
        const formData = { threadID, page: 1, limit: 1000 };

        const res = await Library.makePostRequest("getAIchatMessages", formData, false, setAiChatLoading);

        if (res?.data?.status !== 200) {
            Library.showToastMessage({
                type: "error",
                message: `Error: ${res?.data?.message || "Failed to fetch AI chat messages"}`
            });
            return [];
        }

        return res?.data?.data || [];
    };
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (!aiChatWindowOpen || showChatConversation || (!showChatAllPanel && !showChatArchived)) return;

        /*console.log("aiChatWindowOpen, aiChatSidePanelOpen, showChatAllPanel, showChatArchived, showChatConversation", {
            aiChatWindowOpen,
            aiChatSidePanelOpen,
            showChatAllPanel,
            showChatArchived,
            showChatConversation
        });*/

        if (showChatAllPanel) {
            getUserAIchatsRequest("Active").then(data => {
                //map data to currentMessages structure by day
                const mappedData = data.reduce((acc, chat) => {
                    const date = new Date(chat.createdAt);
                    const dateString = date.toLocaleDateString();

                    const existingSection = acc.find(section => section.label === dateString);
                    if (existingSection) {
                        existingSection.messages.push({
                            id: chat.threadID,
                            title: chat.name,
                            isNew: chat.status === "Active",
                            threadID: chat.threadID
                        });
                    } else {
                        acc.push({
                            label: dateString,
                            messages: [
                                {
                                    id: chat.threadID,
                                    title: chat.name,
                                    isNew: chat.status === "Active",
                                    threadID: chat.threadID
                                }
                            ]
                        });
                    }
                    return acc;
                }, []);

                setAiActiveChats(mappedData);
            });
        } else if (showChatArchived) {
            getUserAIchatsRequest("Archived").then(data => {
                console.log("Archived AI chats:", data);
                //setAiArchivedChats(data);

                //map data to currentMessages structure by day
                const mappedData = data.reduce((acc, chat) => {
                    const date = new Date(chat.createdAt);
                    const dateString = date.toLocaleDateString();

                    const existingSection = acc.find(section => section.label === dateString);
                    if (existingSection) {
                        existingSection.messages.push({
                            id: chat.threadID,
                            title: chat.name,
                            isNew: false // Archived chats are not new
                        });
                    } else {
                        acc.push({
                            label: dateString,
                            messages: [
                                {
                                    id: chat.threadID,
                                    title: chat.name,
                                    isNew: false // Archived chats are not new
                                }
                            ]
                        });
                    }
                    return acc;
                }, []);

                setAiArchivedChats(mappedData);
            });
        }
    }, [aiChatWindowOpen, aiChatSidePanelOpen, showChatAllPanel, showChatArchived, showChatConversation]);
    // #endregion

    return (
        <StyledAllChatsPanel className="group-4">
            <div className="chat-bot">
                <div className="frame-1000011451">
                    <div className={`frame-1000011407 ${showChatArchived ? "hoverable" : ""}`} onClick={() => setShowChatArchived(false)}>
                        <div className="frame-1000011456">
                            {!showChatArchived ? (
                                <div className="chats">Chats</div>
                            ) : (
                                <div className="chats">
                                    <img className="chevron-left" src={chevronLeft0} alt="img" /> Archive
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="frame-1000011452">
                        {!showChatArchived && (
                            <div className="chat-bot2">
                                <div className="frame-1000011410 cursor-pointer">
                                    <div className="frame-100001140722" onClick={() => setShowChatArchived(true)}>
                                        <div className="frame-1000011456">
                                            <img alt="img" className="archive" src={Archive0} />
                                            <div className="archived">Archived</div>
                                        </div>
                                        <img alt="img" className="chevron-right2" src={chevronRight0} />
                                    </div>
                                </div>
                            </div>
                        )}

                        {currentMessages.map((section, idx) => (
                            <div className="chat-bot2" key={idx}>
                                <div className="frame-10000114102">
                                    <div className="frame-1000011411">
                                        <div className="today">{section.label}</div>
                                    </div>
                                    <div className="frame-1000011453">
                                        {section.messages.map(msg => (
                                            <MessageTitleButton
                                                key={msg.id}
                                                className={msg.isNew ? "new-message" : ""}
                                                title={msg.title}
                                                setShowDeleteDialog={setShowDeleteDialog}
                                                threadID={msg.threadID}
                                                updateAIchatRequest={updateAIchatRequest}
                                                getAIchatMessagesRequest={getAIchatMessagesRequest}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="frame-10000114074">
                <div className="frame-1000011455">
                    <img alt="img" className="archive2" src={Archive0} />
                    <div className="_1-chat-archived">{`${1} chat archived`}</div>
                </div>
                <div className="undo">Undo</div>
            </div>
        </StyledAllChatsPanel>
    );
}

// #region COMPONENTS
const MessageTitleButton = ({ title, setShowDeleteDialog, threadID, updateAIchatRequest, getAIchatMessagesRequest }) => {
    return (
        <div
            className="frame-1000011412"
            onClick={() => {
                console.log("Message Title Button Clicked:", threadID);

                // Call the getAIchatMessagesRequest function to fetch messages for the selected thread
                getAIchatMessagesRequest(threadID).then(messages => {
                    console.log("Fetched messages for thread:", threadID, messages);
                    // Here you can handle the fetched messages, e.g., update state or display them
                });
            }}>
            <div className="chat-message-title">{title}</div>

            <ChatDropdown
                setShowDeleteDialog={setShowDeleteDialog}
                threadID={threadID}
                updateAIchatRequest={updateAIchatRequest}
                title={title}
            />
        </div>
    );
};

const ChatDropdown = ({ setShowDeleteDialog, threadID, updateAIchatRequest, title }) => {
    return (
        <StyledChatWindowContent>
            <Dropdown
                trigger={["click"]}
                menu={{
                    items: [
                        {
                            key: "1",
                            label: (
                                <DropdownItem
                                    label="Archive this chat"
                                    onClick={() => {
                                        console.log("Archive Chat Clicked");

                                        // Call the updateAIchatRequest to archive the chat
                                        updateAIchatRequest(threadID, title, "Archived").then(() => {
                                            // Handle successful archiving (e.g., show a toast message)
                                            Library.showToastMessage({
                                                type: "success",
                                                message: "Chat archived successfully"
                                            });
                                        });
                                    }}
                                    imgSrc={Archive0}
                                />
                            )
                        },
                        {
                            key: "2",
                            label: (
                                <DropdownItem
                                    label="Delete chat"
                                    onClick={() => {
                                        console.log("Delete Chat Clicked");
                                        setShowDeleteDialog(true);
                                    }}
                                    imgSrc={LogoutIcon}
                                />
                            )
                        }
                    ]
                }}
                className="cursor-pointer Dropdown-menu-2"
                overlayStyle={{
                    zIndex: 9999999,
                    marginTop: "8px",
                    width: "161px"
                }}
                overlayClassName="dropdown-regular"
                style={{ zIndex: 9999999, top: "10px" }}
                placement="bottomCenter">
                <img className="dots-horizontal" src={DotsHorizontal0} alt="dots-horizontal0.svg" />
            </Dropdown>
        </StyledChatWindowContent>
    );
};

const DropdownItem = ({ label, onClick, imgSrc }) => {
    return (
        <StyledChatWindowContent className="frame-79" onClick={onClick}>
            {imgSrc && <img className="edit-05" src={imgSrc} alt="img" />}
            <div className="new-chat">{label}</div>
        </StyledChatWindowContent>
    );
};
// #endregion
